export const ASSINATURA_SECRETARIO_NAO_CADASTRADA =
  "Assinatura do secretario nao cadastrada, favor entrar em contato com o suporte.";

const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export async function parseAssinaturaSecretarioResponse(response) {
  if (!response) {
    return { cadastrada: false, message: ASSINATURA_SECRETARIO_NAO_CADASTRADA };
  }

  const status = response.status;
  const data = response.data;

  if (status === 404) {
    let message = ASSINATURA_SECRETARIO_NAO_CADASTRADA;
    try {
      const text =
        typeof data === "string"
          ? data
          : data instanceof Blob
            ? await data.text()
            : JSON.stringify(data);
      const json = JSON.parse(text);
      if (json?.message) message = json.message;
    } catch {
      /* keep default */
    }
    return { cadastrada: false, message };
  }

  if (status !== 200 || !data) {
    return { cadastrada: false, message: ASSINATURA_SECRETARIO_NAO_CADASTRADA };
  }

  const dataUrl = await blobToDataUrl(data);
  return { cadastrada: true, dataUrl };
}

export function resolverFormatoImagemAssinatura(dataUrl) {
  if (typeof dataUrl === "string" && dataUrl.includes("image/png")) {
    return "PNG";
  }
  return "JPEG";
}
